<template>
    <div class="page-box">
        <div class="flag-box" @mouseenter="mouseEnter" @mouseleave="mouseLeave">
            <img src="../img/home/applet.png" />
            <span>微信小程序</span>
        </div>
        <div class="img-box" :class="isShow ? 'show-img' : ''">
            <img src="../img/home/appletImg.jpg" />
            <div class="text">打开微信“扫一扫”<br/>进入HeroData小程序</div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isShow: false
        }
    },
    methods: {
        // 鼠标移入
        mouseEnter() {
            this.isShow = true
        },

        // 鼠标移出
        mouseLeave() {
            this.isShow = false
        }
    }
}
</script>

<style lang="scss" scoped>
    .page-box{
        position: fixed;
        top: 85%;
        right: 24px;
        transform:translateY(-85%);
        z-index: 2000;
    }
    .flag-box{
        width: 72px;
        height: 72px;
        overflow: hidden;
        background: #196EED;
        box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.2);
        border-radius: 4px;
        text-align: center;
        cursor: pointer;
        img{
            display: block;
            width: 32px;
            height: 32px;
            margin: 10px 20px 4px;
        }
        span{
            font-size: 12px;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 16px;
        }
    }

    .img-box{
        // opacity: 0;
        display: none;
        position:absolute;
        bottom: 0;
        right: 84px;
        z-index: -1;
        width: 200px;
        height: 258px;
        background: #FFFFFF;
        box-shadow: 0px 1px 12px 0px rgba(0, 0, 0, 0.14);
        border-radius: 4px;
        text-align: center;
        transition: all 0.35s;
        transform: translateX(12px) translateY(12px);
        img{
            display: block;
            width: 160px;
            height: 160px;
            margin: 24px 20px 12px;
        }
        .text{
            font-size: 14px;
            color: #333333;
            line-height: 20px;
        }
    }

    .show-img{
        z-index: 1;
        transform: translateX(0) translateY(0);
        // opacity: 1;
        display: block;
    }
</style>